import { faList } from "@fortawesome/free-solid-svg-icons"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export interface RiskDistributionItem {
  label: string
  color: string
  count: number
}

function SectionTitle({ children, icon }: { children: React.ReactNode; icon?: IconDefinition }) {
  return (
    <div className="flex h-[22px] items-start justify-center">
      <div className="flex items-center justify-center font-normal leading-tight">
        {icon && (
          <>
            <FontAwesomeIcon icon={icon} />
            &nbsp;
          </>
        )}
        <span>{children}</span>
      </div>
    </div>
  )
}

export default function PhysicalRisksIdentifiedWidget({
  riskDistribution
}: {
  riskDistribution: RiskDistributionItem[]
}) {
  const total = riskDistribution.reduce((sum, item) => sum + item.count, 0)
  let cursor = 0

  const gradient = total
    ? riskDistribution
        .map((item) => {
          const start = cursor
          const end = cursor + (item.count / total) * 100
          cursor = end
          return `${item.color} ${start}% ${end}%`
        })
        .join(", ")
    : "#E6E6E6 0% 100%"

  return (
    <div className="flex h-[130px] min-w-[120px] flex-1 flex-col items-center text-center">
      <SectionTitle icon={faList}>Risques identifiés</SectionTitle>

      <div className="flex flex-1 items-center justify-center">
        <div className="relative h-[72px] w-[72px] rounded-full" style={{ background: `conic-gradient(${gradient})` }}>
          <div className="absolute inset-[15px] flex items-center justify-center rounded-full bg-white">
            <b className="text-lg">{total}</b>
          </div>
        </div>
      </div>
    </div>
  )
}
